/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 *
 */
export default function pick(obj, list) {
  var nextObj = {};

  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      if (
        list[key] === true || // Temporary until ARIA is mapped to explicit props
        key.indexOf('aria-') === 0
      ) {
        nextObj[key] = obj[key];
      }
    }
  }

  return nextObj;
}
